<template>
  <div class="register-feature-description">
    <b-container>
      <b-row>
        <b-col class="p-5">
          Lorem ipsum, dolor sit amet consectetur adipisicing elit. Architecto
          fugit alias quibusdam, aliquid quaerat assumenda. Earum assumenda
          tempora expedita nihil quos quisquam architecto quam commodi!
        </b-col>
        <b-col class="p-5">
          Lorem ipsum, dolor sit amet consectetur adipisicing elit. Architecto
          fugit alias quibusdam, aliquid quaerat assumenda. Earum assumenda
          tempora expedita nihil quos quisquam architecto quam commodi!
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
